import { LearningMaterialSummary } from "shared/request/myHealthyAdvantageApi";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import classNames from "classnames";
import { forwardRef } from "react";
import { ReactComponent as PlayCircleIcon } from "shared/assets/Icons/play-circle.svg";

const PLAYABLE_ARTICLE_TYPES = ["podcast", "video"];

export const isPlayableResource = (articleType: string) => PLAYABLE_ARTICLE_TYPES.includes(articleType);

export type ResourceCardProps = {
  item: LearningMaterialSummary;
  navigateBasePath?: string;
  className?: string;
  handleClick?: () => void;
  delayExperienceModal?: boolean;
};

export const ResourceCard = forwardRef<HTMLDivElement, ResourceCardProps>(
  ({ item, navigateBasePath = "/resources/", className, handleClick, delayExperienceModal }: ResourceCardProps, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { handlePositiveMoment } = useAppReviewContext();

    const typeLabel = t<string>(`navigation.search.articleType-${item.articleType}`);

    const handleResourceClick = () => {
      trackEvents(EventNames.RESOURCE_CLICK, {
        value: item.title,
        type: item.articleType,
        categories: item.categories.map((category) => category.name).join(","),
      });
      if (!!handleClick) {
        handleClick();
      } else {
        navigate(`${navigateBasePath}${item.id}`);
      }
      handlePositiveMoment(delayExperienceModal);
    };

    return (
      <button type="button" className={classNames("h-[250px] w-full text-left space-y-3 flex flex-col", className)} onClick={handleResourceClick}>
        <RoundedCard ref={ref} className="relative overflow-hidden h-3/5" padding="p-0">
          <img
            className="object-cover object-center w-full h-full aspect-[3/2]"
            src={`${item.image.url}?h=820`}
            alt={item.image.title || item.title}
          />
          {isPlayableResource(item.articleType) && <PlayCircleIcon aria-hidden className="absolute bottom-3 left-3 w-12 h-12" />}
        </RoundedCard>
        <div>
          <h3 className="!p-0 mb-1 line-clamp-2">{item.title}</h3>
          <p className="text-grey">{typeLabel}</p>
        </div>
      </button>
    );
  }
);
